import { User } from '@/types/api';
import { RemoteFile } from '@/components/file-thumbnail/utils';

//TODO @자올 나중에 작성/수정쪽 타입 정리하기
export enum BoardCommentSection {
  BOTTOM = 'footerSection',
  RIGHT = 'rightSection',
}
export enum BoardViewType {
  NORMAL = 'normal',
  SLIDE = 'slide',
}

export type BoardCategory = { id: string; name: string };

export type DeployStepName =
  | 'codebuild_start'
  | 'security_scan'
  | 'build'
  | 'deploy';

export type DeployStepStatus = 'pending' | 'in_progress' | 'completed' | 'error';

export interface BoardDeployStatusResponse {
  step: string;
  status: string;
  url?: string;
}

export interface BoardDeployFailStatusResponse {
  step: string;
  status: string;
  data: {
    reason: string;
    error: string;
    details: any;
  };
}

export const isDeploySuccess = (
  response: BoardDeployStatusResponse,
): boolean => {
  return response.step === 'deploy' && response.status === 'success';
};

export const isDeployFailed = ({ status }: BoardDeployStatusResponse) =>
  status === 'failed';

export const DefaultDeployMessage = 'AI가 파일을 확인하고 있어요.';
export const getDeployStatusMessage = (
  response: BoardDeployStatusResponse,
): string => {
  const { step, status } = response;

  if (status === 'failed') {
    return getDeployFailureMessage(response);
  }
  if (step === 'codebuild_start' && status === 'success') {
    return '코드 빌드를 시작합니다.';
  }
  if (step === 'security_scan' && status === 'success') {
    return '보안 검사를 통과했습니다.';
  }
  if (step === 'security_scan' && status === 'warning') {
    return '보안 검사를 통과했습니다.';
  }
  if (step === 'build' && status === 'success') {
    return '코드 빌드에 성공했습니다.';
  }
  if (step === 'deploy' && status === 'success') {
    return '배포에 성공했습니다.';
  }

  return DefaultDeployMessage;
};

export const getDeployFailureMessage = (
  response: BoardDeployStatusResponse,
): string => {
  let errorMessage = '오류가 발생했어요.\nIT Service에 문의해 주세요.';
  const errorResponse = response as BoardDeployFailStatusResponse;
  if (errorResponse?.data?.error) {
    errorMessage = errorResponse.data?.error;
  }

  return errorMessage;
};

export interface BoardDetailData {
  id: string;
  commentGroupId: string;
  categories: BoardCategory[];
  subject: string;
  content: string;
  readersCount: number;
  watchCount: number;
  createdBy: User;
  createdAt: string;
  updatedAt: string;
  feedback: {
    isRecommend: boolean;
    isLike: boolean;
    isBookmark: boolean;
    likesCount: number;
    likes: User[];
    recommendsCount: number;
    recommends: User[];
  };
  config: {
    isCommentEnable: boolean;
    isDeleteEnable: boolean;
    commentSection: BoardCommentSection;
    feedbackSettings: { like: boolean; recommend: boolean; bookmark: boolean };
    viewType: BoardViewType;
    isTemporary: boolean;
    isImportant: boolean;
    isSandbox?: boolean;
    displayStartedAt: string;
    homeDisplayStartedAt?: string;
    homeDisplayEndedAt?: string;
    editorType?: string;
    displaySections: string[];
    isReserved: boolean;
    /** 목록 카드 제목 노출 여부. BE 미배포 환경에서는 오지 않을 수 있다. */
    isListSubjectVisible?: boolean;
  };
  files: {
    attachments: RemoteFile[];
    slideImages: RemoteFile[];
    thumbnails: RemoteFile[];
  };
  axLoungeDeploy?: {
    files: Array<{
      fileUuid: string;
      version: string;
      uploadedAt: string;
      url: string;
    }>;
    state: {
      step: string;
      status: string;
      timestamp: string;
      data: any;
    } | null;
  };
}
